/* 

For payment with Razorpay

*/
export const initRazorpayPayment = async (
    paymentDetails,
    checkoutId,
    callbackFunc
) => {
    let options = {
        "key": paymentDetails.public_key,
        "amount": paymentDetails.amount.amount,
        "currency": paymentDetails.amount.currency,
        "name": "Shoptype",
        "image": "https://app.shoptype.com/static/media/logo.636341ad.png",
        "order_id": paymentDetails.id,
        "handler": (response) => {
            if (response.razorpay_payment_id) {
                callbackFunc({ status: 'success', message: 'Payment Successful', transactionId: paymentDetails.id });
            } else {
                callbackFunc({ status: 'failed', message: 'Payment Failed', transactionId: paymentDetails.id });
            }
        },
        "modal": {
            "ondismiss": () => {
                callbackFunc({ status: 'closed' });
            }
        },
        "prefill": {
            "name": paymentDetails.billing_address.name,
            "email": paymentDetails.billing_address.email,
            "contact": paymentDetails.billing_address.phone
        },
        "notes": {
            "Checkout ID": checkoutId
        },
        "theme": {
            "color": '#B69903'
        }
    };

    let razorpayHandler = new Razorpay(options);
    razorpayHandler.open();
}